import React from 'react'
import { BaseProvider } from '@!/providers'
import { PurchaseComplete } from '@!/ExternalPayment/CoinPurchase/containers/PurchaseComplete'

export default function PurchaseCompleteApp({ purchased_coin_count, total_coin_count, price }) {
  // 購入完了データをオブジェクトにまとめる
  const purchaseData =
    purchased_coin_count != null && total_coin_count != null && price != null
      ? {
          purchasedCoinCount: purchased_coin_count,
          totalCoinCount: total_coin_count,
          price: price,
        }
      : null

  return (
    <BaseProvider>
      <PurchaseComplete purchaseData={purchaseData} />
    </BaseProvider>
  )
}
